import { authFetch } from '../utils/authFetch';

export async function syncPushSubscription(subscription: PushSubscription): Promise<boolean> {
  const response = await authFetch('/api/notifications/subscribe', {
    method: 'POST',
    autoLogout: false,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subscription),
  });
  return response.ok;
}

export async function fetchPushVapidPublicKey(): Promise<string> {
  const response = await authFetch('/api/notifications/vapid-key', { autoLogout: false });
  if (!response.ok) {
    throw new Error('Failed to get notification key from server');
  }

  const payload = (await response.json()) as { publicKey?: string };
  if (!payload.publicKey) {
    throw new Error('Missing notification public key');
  }

  return payload.publicKey;
}

export async function savePushSubscription(subscription: PushSubscription): Promise<void> {
  const response = await authFetch('/api/notifications/subscribe', {
    method: 'POST',
    autoLogout: false,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subscription),
  });
  if (!response.ok) {
    throw new Error('Server rejected push subscription');
  }
}
